import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {deleteConnectorData, getConnectorDatas,} from "../../../redux/modules/Connector/action";

class Connector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getConnectorDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.connector.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const connectorColumn = [
            {
                name: "Connector",
                path: "name",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        addData={true}
                        trashBin={true}
                        path={this.props.location.pathname}
                        title={"Connector Data"}
                        data={this.props.connector.datas}
                        columns={connectorColumn}
                        action={["update", "delete"]}
                        trash={true}
                        deleteAction={(id) => this.props.deleteConnectorData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    connector: state.connector,
});

const mapDispatchToProps = {
    getConnectorDatas,
    deleteConnectorData,
};

export default MainLayout(connect(mapStateToProps, mapDispatchToProps)(Connector));
